import axios from "axios";
import Cookies from "universal-cookie";
import { TOKEN_STORE_KEY } from "@/constants/storage";
import { T_TOKEN_STORE_KEY } from "@/constants/storage";
import { apiUrl } from "@/config/config";

const api = axios.create({
  baseURL: apiUrl,
});

const authApi = axios.create({
  baseURL: apiUrl,
});

const teacherAuthApi = axios.create({
  baseURL: apiUrl,
});

authApi.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    const access_token = cookies.get(TOKEN_STORE_KEY);

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (err) => {
    console.error(err);
    return Promise.reject(err);
  }
);

teacherAuthApi.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    const access_token = cookies.get(T_TOKEN_STORE_KEY);

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (err) => {
    console.error(err);
    return Promise.reject(err);
  }
);

export { api, authApi, teacherAuthApi };
